t = require('app/scripts/views/internal/teacup-with-helpers')('board_member_add_multiple')
isDesktop = require('@trello/browser').isDesktop()
{ trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'

module.exports = t.renderable ({ showMultiboardGuestWarning, isTemplate }) ->
  t.div '.invite-board-member-autocomplete.js-autocomplete-root'

  t.hr()

  t.div '.invite-link-actions', ->
    t.span '.invite-with-link', ->
      t.img '.invite-with-link-icon', { src: require('resources/images/icon-link.svg') }
      t.format 'invite-with-link'

    t.a '.action-link.js-show-invitation-link', { href: '#' }, ->
      t.format 'create-link'

    t.a '.action-link.js-deactivate-link.hide.js-invitation-link-container', { href: '#' }, ->
      t.format 'disable-link'

  t.p '.quiet.invite-with-link-description', ->
    if showMultiboardGuestWarning
      t.format 'guests-that-are-already-on-another-team'

      if !isDesktop
        t.text ' '
        helpUrl = 'https://help.trello.com/article/1123-multi-board-guests'
        t.a
          href: helpUrl
          target: '_blank'
          -> l ['templates', 'select_member', 'learn-more']
    else if isTemplate
      t.format 'anyone-with-link-can-join-as-template-member'
    else
      t.format 'anyone-with-link-can-join-as-board-member'

  t.div '.manage-member-invitation-link.hide.js-invitation-link-container', ->
    t.input '.js-invitation-link',
      type: 'text'
      readonly: 'readonly'
      placeholder: t.l 'loading'

    t.button '.primary.js-copy-invitation-link.js-hide-on-copy', ->
      t.format 'copy'
    t.button '.primary.js-copy-invitation-link.js-show-on-copy.hide', ->
      t.format 'copied'
